module.exports = __webpack_public_path__ + "img/h数据集成.62432700.svg";